import React from 'react';

export default function Google(props) {
  return <img src="/images/google.svg" alt="Google" {...props} />;
}
